import React, {FC} from 'react';

import {brandColors} from "../theme/defaultTheme";

// MakerKSH 심볼. logo.jpeg의 면 분할을 그대로 벡터로 옮겨서
// 여백 없이, 어떤 크기에서도 또렷하게 쓸 수 있게 만든 마크.
const FACETS: { d: string; fill: string }[] = [
    {d: 'M147 0 L147 160 L71 252 L2 213 Z', fill: brandColors.blue},
    {d: 'M147 160 L71 252 L147 292 Z', fill: brandColors.deep},
    {d: 'M2 213 L71 252 L2 333 Z', fill: brandColors.mist},
    {d: 'M71 252 L147 292 L2 505 L2 333 Z', fill: brandColors.sky},
    {d: 'M147 292 L264 366 L264 507 L147 433 Z', fill: brandColors.blue},
];

const RATIO = 264 / 507;

interface BrandMarkProps {
    height?: number;
    // 단색으로 찍고 싶을 때(워터마크, 푸터 등) 색을 직접 지정한다.
    color?: string;
    opacity?: number;
    title?: string;
}

const BrandMark: FC<BrandMarkProps> = ({height = 24, color, opacity = 1, title}) => {
    return (
        <svg
            width={Math.round(height * RATIO * 100) / 100}
            height={height}
            viewBox="0 0 264 507"
            xmlns="http://www.w3.org/2000/svg"
            role={title ? 'img' : 'presentation'}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            style={{display: 'block', opacity, flexShrink: 0}}
        >
            {title && <title>{title}</title>}
            {FACETS.map((facet) => (
                <path key={facet.d} d={facet.d} fill={color ?? facet.fill}/>
            ))}
        </svg>
    );
};

export default BrandMark;
